<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/56pNYU/images/e9781439635360_cover.jpg?1684514597586" alt="This image is the cover for the book University of Tennessee, Campus History"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">University of Tennessee, Campus History
      </h1>
      <p class="bookDescription body article font2">
        <p>In 1794, two years before Tennessee became a state, the legislature of the Southwest Territory chartered Blount College in Knoxville as one of the first three colleges established west of the Appalachian Mountains. In 1807, the school changed its name to East Tennessee College. The school relocated to a 40-acre tract, known today as �the Hill,� in 1828 and was renamed East Tennessee University in 1840. The Civil War literally shut down the university. Students and faculty were recruited to serve on battlefields, and troops used campus facilities as hospitals and barracks. In 1869, East Tennessee University became the state�s land-grant institution under the auspices of the 1862 Morrill Act. In 1879, the state legislature changed the name of the institution to the University of Tennessee. By the early 20th century, the university admitted women, hosted teacher institutes, and constructed new buildings. Since that time, the University of Tennessee has established campuses and programs across the state. Today, in addition to a rich sports tradition, the University of Tennessee provides Tennesseans with unparalleled opportunities.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Aaron D. Purcell
      </h2>
      
      <p class="authorDescription body article">Aaron D. Purcell holds a doctorate in history from the University of Tennessee and has served as university archivist since 2000. This book draws from the rich holdings of the university archives and other photographic collections at the University of Tennessee.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Arcadia Publishing
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?304c54d8